import React, { useState } from 'react';
import axios from 'axios';
import { Alert, Button, Container, Form } from 'react-bootstrap';

const InstrumentDownload = () => {
    const [url, setUrl] = useState('https://margincalculator.angelbroking.com/OpenAPI_File/files/OpenAPIScripMaster.json');
    const [status, setStatus] = useState('');
    const [error, setError] = useState('');

    const handleDownload = async () => {
        setStatus('Downloading...');
        setError('');

        try {
            const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/download-json`, { url }, {
                responseType: 'blob'
            });

            const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = blobUrl;
            link.setAttribute('download', `instrumental_${Date.now()}.csv`);
            document.body.appendChild(link);
            link.click();
            link.remove();

            setStatus('Download complete!');
        } catch (error) {
            console.error('Error downloading file:', error);
            setError(
                error.response?.status === 401
                    ? 'Session expired. Please log in again.'
                    : error.response?.data?.message || 'Error downloading file'
            );
            setStatus('');
        }
    };

  return (
    <Container className="mt-4 p-4 bg-white rounded shadow">
      <h2 className="mb-4">Instrument Data Download</h2>
      <Form.Group className="mb-3">
        <Form.Label>JSON URL</Form.Label>
        <Form.Control
          type="text"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          placeholder="Enter JSON URL"
          className="mb-3"
        />
      </Form.Group>
      <Button
        variant="primary"
        onClick={handleDownload}
        disabled={!url}
        className="mb-3"
      >
        Download CSV
      </Button>
      {status && <Alert variant="success">{status}</Alert>}
      {error && <Alert variant="danger">{error}</Alert>}
    </Container>
  );
};

export default InstrumentDownload;